<template>
  <module
    ref="module"
    id="mat_details"
    titleIcon="fa fa-desktop"
    :title="`${$t('mats')} ${$t('detailstxt')}`"
    :use-default-list="false"
  >
    <template slot="toolbar-global">
      <p-button round outline @click="prevPage">
        <i slot="label" class="nc-icon nc-minimal-left"></i> {{ $t('back') }}
      </p-button>
    </template>

    <div slot="global">
      <!-- In progress -->
      <div v-if="inprogress" class="text-center">
        <h2>{{ inprogresstxt }}</h2>
        <i class="fa fa-cog fa-spin fa-huge fa-fw" style="color: #51bcda;"></i>
      </div>

      <div v-else class="row mx-2">
        <!-- MAT Header -->
        <div class="mat-header-container">
          <div class="mat-header-left">
            <h1 class="mat-name">{{ mat.name }}</h1>
            <div class="counter-wrapper">
              <div class="counter-item">
                <div class="count master-count">{{ mat.masters || 0 }}</div>
                <label class="count-label">M</label>
              </div>
              <div class="counter-item">
                <div class="count follower-count">{{ mat.followers || 0 }}</div>
                <label class="count-label">F</label>
              </div>
              <div class="counter-item">
                <div class="count total-count">{{ mat.total_platforms || 0 }}</div>
                <label class="count-label">T</label>
              </div>
              <div class="counter-item">
                <div class="count mt4-count">{{ mat.mt4_count }}</div>
                <label class="count-label">MT4</label>
              </div>
              <div class="counter-item">
                <div class="count mt5-count">{{ mat.mt5_count }}</div>
                <label class="count-label">MT5</label>
              </div>
            </div>
          </div>
          <div class="mat-header-right">
            <div class="gauges">
              <GaugeChart :value="mat.cpu_percent" label="CPU" />
              <GaugeChart :value="mat.ram_percent" label="RAM" />
            </div>
            <el-tooltip :content="'Robot last reported about ' + minutesAgo(mat.last_update) + 'min ago'" placement="top">
              <i class="fa fa-android robot-icon" :class="getStatusClass(mat.last_update)" />
            </el-tooltip>
          </div>
        </div>

        <el-table
          v-if="mat.platforms && mat.platforms.length"
          :data="mat.platforms"
          style="width: 100%"
          border
          stripe
        >
          <el-table-column prop="userid" label="User ID" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="first_name" label="First Name" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="last_name" label="Last Name" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="account" label="Account" sortable align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="strat_name" label="Strat Name" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="platform" label="Platform" width="60" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="type" label="Type" width="60" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ `${scope.row.type === 'master' ? 'M' : 'F'}` }}
            </template>
          </el-table-column>
          <el-table-column prop="balance" label="Balance" sortable align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="profit" label="Profit" sortable align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="ram_usage" label="RAM Usage" sortable width="100" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ `${scope.row.ram_usage}MB` }}
            </template>
          </el-table-column>
          <el-table-column prop="cpu_usage" label="CPU Usage" sortable width="100" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ `${scope.row.cpu_usage}%` }}
            </template>
          </el-table-column>
          <el-table-column prop="last_update" label="Last Update" sortable show-overflow-tooltip>
            <template slot-scope="scope">
              {{ $moment(scope.row.last_update).format('YYYY-MM-DD HH:mm:ss') }}
            </template>
          </el-table-column>
        </el-table>

      </div>
    </div>
  </module>
</template>
<script>
import Vue from 'vue'
import { Card, Col, Tooltip, Table, TableColumn, Row } from "element-ui";
Vue.use(Card);
Vue.use(Col);
Vue.use(Row);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tooltip);

const user_data = JSON.parse(localStorage.getItem("user-info"));

export default {
  components: {
    Card,
    Col,
    Table,
    TableColumn,
    Tooltip,
    Row,
  },
  data () {
    return {
      mat: {},
      inprogress: false,
      inprogresstxt:
        this.$t("loadingtxt") +
        " " +
        this.$t("mats") +
        ". " +
        this.$t("pleasewait"),
    }
  },
  methods: {
    formatHeader (key) {
      return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
    },
    prevPage () {
      window.history.back();
    },
    minutesAgo(timestamp) {
      const now = Date.now();
      const updated = new Date(timestamp).getTime();
      return Math.floor((now - updated) / 60000); // in minutes
    },
    getStatusClass(timestamp) {
      return this.minutesAgo(timestamp) > 10 ? 'red' : 'green';
    },
  },
  mounted () {
    this.$getMATs(this.$route.params.mat_server)
        .then(
          (resp) => {
            this.mat = resp.data
            this.inprogress = false;
          },
          this.failOp
        );
  },
  created () {
    this.inprogress = true;
    this.$setTranslatingInProgress()
  },
  beforeDestroy () {
    this.$root.$off("showTranslatingProgress")
  },
  }
</script>
<style scoped lang="scss">
.mat-header-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 1rem;
}
.mat-name {
  margin: 0 0 1rem 0.25rem;
  font-size: 2.25rem;
  font-weight: bold;
  color: #409EFF;
}
.counter-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.counter-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.count {
  border-radius: 50px;
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  display: inline-block;
  font-weight: bold;
  height: 32px;
  line-height: 32px;
  text-align: center;
  min-width: 2.5rem;
  padding: 0;
  font-size: 1rem;
}
.master-count {
  color: #ee9f3d;
  border: 3px solid #ee9f3d;
}
.follower-count {
  color: #35c399;
  border: 3px solid #35c399;
}
.total-count {
  color: #3f79e8;
  border: 3px solid #3f79e8;
}
.mt4-count {
  color: #bd77e6;
  border: 3px solid #bd77e6;
}
.mt5-count {
  color: #7466ef;
  border: 3px solid #7466ef;
}
.mat-header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}
.gauges {
  display: flex;
  gap: 1rem;
}
/* Robot in top-right */
.robot-icon {
  font-size: 2.5rem;
}
.robot-icon.green {
  color: #67C23A;
}
.robot-icon.yellow {
  color: #E6A23C;
}
.robot-icon.red {
  color: #F56C6C;
}
.mat-header-divider {
  border: none;
  border-bottom: 1px solid #ccc;
}
</style>
